export default function Differentials() {
  const differentials = [
    {
      icon: 'ri-global-line',
      title: 'Educação Bilíngue Imersiva',
      description: 'Mais que aulas de inglês, seu filho vive o inglês! Até os 3 anos de idade, a imersão é 100% na Língua Inglesa, proporcionando uma aquisição natural e fluida. Dos 4 aos 5 anos, a imersão é de 75% em inglês, com o início do aprendizado da Língua Portuguesa, garantindo um desenvolvimento equilibrado e completo.'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Aprendizagem Integrada de Conteúdo e Linguagem',
      description: 'Seu filho aprende conteúdos curriculares (matemática, ciências, história) diretamente em inglês. Isso não só aprofunda a fluência, mas também desenvolve o pensamento crítico e a capacidade de resolver problemas em diferentes contextos linguísticos.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Estímulo à Criatividade e Metacognição',
      description: 'Nossas propostas são lúdicas e incentivam a experimentação, a descoberta e o compartilhamento de ideias. Estimulamos a criança a pensar sobre como ela aprende, desenvolvendo a metacognição – a chave para um aprendizado autônomo e eficaz.'
    },
    {
      icon: 'ri-book-2-line',
      title: 'Material Didático Exclusivo e Inovador',
      description: 'Desenvolvemos materiais pedagógicos próprios, como a coleção \'Enjoyable English\', que alinha os conteúdos da BNCC com as tendências da Educação do Século XXI. Seu filho terá acesso a recursos interativos e modernos que tornam o aprendizado uma aventura diária.'
    }
  ];

  return (
    <section id="pedagogico" className="py-20 bg-gradient-to-b from-white to-red-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-6">
            Diferenciais pedagógicos da The Joy School Paulínia
          </h2>
          <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Nossa metodologia é o coração da The Joy School, cuidadosamente desenvolvida para nutrir a curiosidade e o amor pelo aprendizado em cada criança:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {differentials.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-red-100"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-slate-600 to-slate-800 rounded-2xl mb-6 shadow-lg">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
                {item.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
